import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {InfoIcon} from '@primer/octicons-react'
import {Button} from '@primer/react'
import {useRef, useState} from 'react'
import {OverviewSidePanel} from './OverviewSidePanel'

/**
 * Renders a button that opens the overview side panel
 */
export function OpenOverviewSidePanelButton() {
  const [overviewSidePanelIsOpen, setOverviewSidePanelIsOpen] = useState(false)
  const toggleSidePanelRef = useRef<HTMLButtonElement>(null)

  return (
    <div className="d-flex flex-items-center">
      <ErrorBoundary
        fallback={
          <Button
            aria-label="The overview side panel cannot currently be opened."
            leadingVisual={InfoIcon}
            size="small"
            variant="invisible"
          />
        }
      >
        <Button
          ref={toggleSidePanelRef}
          aria-label="Open overview side panel"
          leadingVisual={InfoIcon}
          size="small"
          onClick={() => {
            setOverviewSidePanelIsOpen(true)
          }}
        />
        {overviewSidePanelIsOpen && <OverviewSidePanel onClose={() => setOverviewSidePanelIsOpen(false)} />}
      </ErrorBoundary>
    </div>
  )
}

try{ OpenOverviewSidePanelButton.displayName ||= 'OpenOverviewSidePanelButton' } catch {}